export default __webpack_public_path__ + "static/media/SunmiScannerRed.a9f3d44d.svg";